// Should stay in sync with MoveLicenseTypes.mjs

export const MOVE_LICENSE_TYPES = {
  ISACA: 1,
  MDDAP: 2,
  MDDAP_OU: 3,
  FREE: 4,
  PAID: 5
};
